import Marionette from 'backbone.marionette';
import RenewSessionView from './renew-session-view.js';
import ScopeSearchInputView from './scope-search-input-view.js';

// The number of milliseconds to display the renew session dialog before
// logging out the user.
const WARNING_TIMESPAN = 120000;

// The number of milliseconds between polls for session expiration.
const POLL_RATE = 10000;

/**
 * A view which represents the layout of a page. View for navigation,
 * content, etc., may be added to this view.
 */
export default Marionette.View.extend({

    el: 'body',

    template: false,

    ui: {
        scopeAndSearch: '#bible-search',
        logoutControl: '#user .logout'
    },

    events: {
        'click @ui.logoutControl': 'signInOrOut'
    },

    /**
     * Initialize the view.
     *
     * @param {Object} options - Marionette.View options, including common
     *     options such as user used in views across the application.
     *
     * @param {User} options.user - A user model, which becomes the model
     *     for the view.
     */
    initialize: function (options) {

        this.model = options.user;

        if (this.getUI('scopeAndSearch').length != 0) {
            this.scopeSearchInputView = new ScopeSearchInputView({
                ...options,
                ...{ el: this.getUI('scopeAndSearch') }
            });
        }

        // Check periodically to see if we are near or past the user's login
        // session expiration.

        this.renewSessionModal = null;
        this.interval =
            window.setInterval(this.checkExpiration.bind(this), POLL_RATE);
    },

    /**
     * When the login control is clicked, if we have a user, logout the
     * user and remove the user from the model.
     */
    signInOrOut: function (event) {

        if (this.model && this.model.get('id')) {

            event.preventDefault();

            this.listenToOnce(this.model, 'logout', () => {
                window.location.reload();
            });

            this.model.logout();
        }
    },

    /**
     * Check to see if the user's login session has expired or will expire soon.
     */
    checkExpiration: function () {

        let exp = this.model.get('exp');

        if (exp) {

            exp = exp * 1000;
            const nextPoll = Date.now() + POLL_RATE;

            if (nextPoll > exp) {
                this.model.logout();
            } else if (nextPoll + WARNING_TIMESPAN > exp) {

                if (this.renewSessionModal !== null) {
                    // Already displayed.
                    return;
                }

                this.renewSessionModal =
                    new RenewSessionView({ model: this.model });
                this.renewSessionModal.render();
                this.listenToOnce(this.renewSessionModal, 'destroy', () => {
                    this.renewSessionModal = null;
                });
            }
        }
    }
});
